export const ENABLE_ACCOUNT_LINKING: boolean = false;

export const SHOW_VENUE_LOGO: boolean = false;

export const SHOW_BLOG: boolean = false;

export const SHOW_PARTNERS: boolean = false;
